import { useState, useEffect } from "react";
import {
  fetchEstimatesById,
  getEstimateNotes,
  saveEstimateNotes,
} from "../../../actions/client/estimates";
import { useParams } from "react-router-dom";
import Badge from "../../../components/admin/Badge";
import NotesSVG from "../../../utils/assets/client/wirte.svg";
import ProfileIcon from "../../../components/client/ProfileIcon";
import ProfileSVG from "../../../utils/assets/client/user.svg";
import { toast } from "react-toastify";
import AdminComments from "../../../components/admin/AdminComments";
import { getEstimatePDF } from "../../../actions/admin/estimates";
import { generateTicket } from "../../../actions/admin/leads";

const EstimatePage = () => {
  const [estimateDetails, setEstimateDetails] = useState([]);
  const [notesDetails, setNotesDetails] = useState([]);

  const { id } = useParams();

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetchEstimatesById(token, id).then((res) => {
      setEstimateDetails(res.data);
      getEstimateNotes(token, res.data.id).then((res) => {
        setNotesDetails(res.data);
      });
    });
  }, []);

  const handleComments = async (note, boolValue) => {
    const token = localStorage.getItem("token");

    const data = {
      estimate_id: id,
      note,
      is_internal: boolValue,
    };

    await saveEstimateNotes(token, data).then((res) => {
      if (res.success == true) {
        toast.success("Note Added Successfully");
        getEstimateNotes(token, estimateDetails.id).then((res) => {
          setNotesDetails(res.data);
        });
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const handleEstimateDownload = async () => {
    const token = localStorage.getItem("token");
    try {
      const pdfBlob = await getEstimatePDF(token, id);
      // Create a URL for the blob
      const url = window.URL.createObjectURL(
        new Blob([pdfBlob], { type: "application/pdf" })
      );
      // Open the PDF in a new tab
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error opening the PDF:", error);
    }
  };

  // TODO: Implement Conver to Ticket API
  const convertToTicket = () => {
    const token = localStorage.getItem("token");
    const leadId = estimateDetails?.lead_id
    generateTicket(leadId, token).then((res) => {
      if(res?.success){
        toast.success("Ticket Generated succssfully!")
      }else{
        toast.error("Something went wrong, try again!")
      }
    }).catch((error) => {
      toast.error("Something went wrong, try again!")
    })
  }

  return (
    <div className="mx-4 bg-light">
      <div className=" mb-2">
        <div className="d-flex row justify-content-between align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <h3 className="text-black my-3">
              Estimate #{estimateDetails?.id}
            </h3>
          </div>
          <div className="d-flex justify-content-lg-end justify-content-between col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <button
              className="text-white btn  py-2 px-4 border-0"
              style={{ backgroundColor: `${estimateDetails?.color_code}` }}
            >
              {estimateDetails?.status}
            </button>
            <button className="btn bg-black
             text-white mx-3 py-0 py-lg-2 px-4 " onClick={() => convertToTicket()}>
              Convert to Ticket
            </button>
            <div className="dropdown">
              <button
                className="btn bg-black  py-0 py-lg-2 px-4 text-white dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Action
              </button>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" onClick={() => handleEstimateDownload()}  >Download Estimate</a></li>
              </ul>
            </div>

            {/* <button className="bg-black card_radius text-white py-2 px-4 border-0">
              Action
            </button> */}
          </div>
        </div>
      </div>
      <div className="mb-4 rounded">
        <div style={{fontSize: "16px"}} className="row p-2 rounded py-4 pb-5 bg-white shadow border_bg_col d-flex justify-content-center align-items-start">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div>
              <p className="mb-0 txt-head">Estimate</p>
              <hr className="my-1 mb-2" />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div>
              <p className="mb-0  txt-head">Estimate To</p>
              <hr className="my-1 mb-2" />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div>
              <p className="mb-0  txt-head">Estimate Summary</p>
              <hr className="my-1 mb-2" />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="d-flex flex-column ">
              <span>Unit 1, 7 Waterfront House</span>
              <span>Wembley</span>
              <span>HA0 1TX</span>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="d-flex flex-column txt-secondary">
              <span
                className="text-success"
                style={{ fontSize: "20px", fontWeight: "550" }}
              >
                {estimateDetails?.lead?.customer?.first_name}{" "}
                {estimateDetails?.lead?.customer?.last_name}
              </span>
              <p className="text-black mb-0">
                Mobile:{" "}
                <span className="">
                  {estimateDetails?.lead?.customer?.phone}
                </span>{" "}
              </p>
              <p className="text-black mb-0">
                Email:{" "}
                <span className="">
                  {estimateDetails?.lead?.customer?.email}
                </span>{" "}
              </p>
              <p className="text-black mb-0">
                Address:{" "}
                <span className="">
                  {estimateDetails?.lead?.customer?.address}
                </span>{" "}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="d-flex flex-column ">
              <p className="text-black mb-0">
                Estimate Number:{" "}
                <span className="">{estimateDetails?.id}</span>{" "}
              </p>
              <p className="text-black mb-0">
                Estimate Date:{" "}
                <span className="">
                  {estimateDetails && estimateDetails?.created_at
                    ? new Date(estimateDetails?.created_at).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }
                      )
                    : "-"}
                </span>{" "}
              </p>
              <div className="text-black mb-0 d-flex justify-content-start align-items-center">
                <span >Estimate Status: </span>
                
                <span className="badge mx-1" style={{backgroundColor: `${estimateDetails?.color_code}`}}>
                  {estimateDetails?.status}
                </span>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div>
              <p className="mb-0 txt-stale txt-head">Estimate</p>
              <hr className="my-1 mb-2" />
            </div>
            <div className="d-flex flex-column txt-secondary">
              <span>Unit 1, 7 Waterfront House</span>
              <span>Wembley</span>
              <span>HA0 1TX</span>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div>
              <p className="mb-0 txt-stale txt-head">Estimate To</p>
              <hr className="my-1 mb-2" />
            </div>
            <div className="d-flex flex-column txt-secondary">
              <span>Sahil Seta</span>
              <span>Mobile: +91 8383838383 </span>
              <span>Email: sahilseta@gmail.com</span>
              <span>Address: sahilseta@gmail.com</span>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div>
              <p className="mb-0 txt-stale txt-head">Estimate Summary</p>
              <hr className="my-1 mb-2" />
            </div>
            <div className="d-flex flex-column txt-secondary">
              <span>Estimate Number: 12</span>
              <span>Estimate Date: 12 Dec 2024 </span>
              <span>Estimate Status: Approved</span>
            </div>
          </div> */}
        </div>
      </div>
      <div className="my-3">
        <div className="row shadow rounded border_bg_col overflow-hidden">
          <p className="txt-head text-white bg-black px-3 p-2 mb-0">
            Estimate Item (s)
          </p>
          <table className="table   table-hover">
            <thead>
              <tr>
                <td>Type</td>
                <td>Device</td>
                <td>Product/Service</td>
                <td>Notes</td>
                <td>Estimate Price</td>
                <td>QTY</td>
                <td>Tax Class</td>
                <td>Discount</td>
                <td>Tax</td>
                <td>Total</td>
              </tr>
            </thead>
            <tbody>
              {estimateDetails?.lead?.lead_items.length > 0
                ? estimateDetails?.lead?.lead_items.map((item) => {
                    return (
                      <tr style={{fontWeight: "400"}} key={item?.id} className="text-black">
                        <td>{item?.delivery_type}</td>
                        <td>
                          {item?.brand?.name} {item?.devices[0].title}
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            {item?.defects &&
                              item?.defects.map((defect) => {
                                return (
                                  <span key={defect?.id}>{defect?.title}</span>
                                );
                              })}
                          </div>
                        </td>
                        <td>
                          {estimateDetails?.notes
                            ? estimateDetails?.notes
                            : "-"}
                        </td>
                        <td>{item?.lead_value}</td>
                        <td>-</td>
                        <td>
                          {estimateDetails?.lead?.customer?.tax_class && estimateDetails?.lead?.customer?.tax_class?.name
                            ? estimateDetails?.lead?.customer?.tax_class?.name
                            : "-"}
                        </td>
                        <td>-</td>
                        <td>{item?.tax}</td>
                        <td>{item?.lead_value + item?.tax}</td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </table>
          <div className="rounded card  total_card  d-flex flex-column justify-content-center text-end p-3 f-16 ">
            <div className="d-flex justify-content-between align-items-center">
              <span>Sub Total :</span>
              <span>£ {estimateDetails?.total_price}</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span>Discount :</span>
              <span>£ 0.00</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span>GST :</span>
              <span>£ {estimateDetails?.total_tax}</span>
            </div>
            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-dark" style={{ fontSize: "20px" }}>
                Total :{" "}
              </span>
              <span className="text-dark" style={{ fontSize: "20px" }}>
                £ {estimateDetails?.total_price + estimateDetails?.total_tax}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="my-3">
        <AdminComments
          notesData={notesDetails}
          submit={handleComments}
          header={"Estimate History"}
        />
      </div>
    </div>
  );
};

export default EstimatePage;
